import React, { Suspense, useState } from 'react'
import { Modal, ModalHeader, Button, ModalBody, ModalFooter, ModalTitle } from 'reactstrap'
import _ from "lodash"
import { useSelector } from 'react-redux'
import moment from "moment"
//************************************//
import { trans } from '@utils'
import { dateFormat } from "@src/assets/data/constants"
import InspectionsWithLowestScoreTable from './statistics/InspectionsBarItemTable'
//************************************//

const PopUpModal = (props) => {
	//************************************//
	const { data } = props
	const { ToolbarDetailsComponent, DetailsComponent, item } = data
	//************************************//
	const loading = useSelector(store => store.app.loading)
	const filters = useSelector(store => store.analytics.filters)
	//************************************//
	const [open, setOpen] = useState(true)
	//************************************//
	const _close = () => {
		setOpen(false)
		props.onClose()
	}
	//************************************//
	const getDate = () => {
		if (item.date) {
			if (item.date.length === 10) {
				return {
					from: item.date,
					to: item.date
				}
			} else if (item.date.length === 7) {
				const fromDiff = moment(item.date).startOf('month').diff(filters.date_from)
				const toDiff = moment(item.date).endOf('month').diff(filters.date_to)
				return {
					from: fromDiff >= 0 ? moment(item.date).startOf('month').format(dateFormat) : moment(filters.date_from).format(dateFormat),
					to: toDiff > 0 ? moment(filters.date_to).format(dateFormat) : moment(item.date).endOf('month').format(dateFormat)
				}
			} else {
				const fromDiff = moment(item.date).startOf('year').diff(filters.date_from)
				const toDiff = moment(item.date).endOf('year').diff(filters.date_to)
				return {
					from: fromDiff >= 0 ? moment(item.date).startOf('year').format(dateFormat) : moment(filters.date_from).format(dateFormat),
					to: toDiff > 0 ? moment(filters.date_to).format(dateFormat) : moment(item.date).endOf('year').format(dateFormat)
				}
			}
		}
	}
	//************************************//
	const finalDate = getDate()
	//************************************//
	return (
		<Modal
			scrollable
			isOpen={open}
			toggle={_close}
			unmountOnClose={true}
			backdrop={true}
			className='modal-xl'
			modalClassName={''}
		>
			<ModalHeader cssModule={{ 'modal-title': 'w-100 d-flex justify-content-between' }} toggle={_close}>
				<span>{data.title}</span>
				<span>{item.date}</span>
			</ModalHeader>
			<ModalBody className='flex-grow-1 p-0 modal-body'>
				<Suspense fallback={<div />}>
					<DetailsComponent date={finalDate} item={item} toolbarDetailsComponent={ToolbarDetailsComponent} />
				</Suspense>
			</ModalBody>
			<ModalFooter>
				<Button type='button' color='secondary' disabled={loading} onClick={_close}>
					<span>{trans('analytics.actions.close')}</span>
				</Button>
			</ModalFooter>
		</Modal>
	)
}
//************************************//
export default PopUpModal
